import React, {useState} from 'react'
import {Navbar} from './components/Navbar'
import {Feeds} from './components/Feeds'
import {Footer} from './components/Footer'


const App = () => {

    // to maintain state of dark theme, we use Hooks(useState)
    const[darkTheme,setDarkTheme] = useState(false)
    //  this initials darkTheme to false.

    return (
        <div className={darkTheme ? 'dark': ''}> {/* Determing the theme and using that to design the below panels*/}
        <div className="bg-gray-100 dark:bg-gray-900 dark:text-white min-h-screen"> {/* min-h-screen -> min height of screen set to 100vh */}
            <Navbar darkTheme={darkTheme} setDarkTheme={setDarkTheme}/> 
            {/* passing props also inside the componet so that we use this dark theme in NavBar component to design theme acc. */}
            <Feeds/>
            <Footer/>
        </div>
        </div>
    );
}
export default App;